import { RootStores } from '../../common/stores';
import { STORE_MONGO_CONSOLE } from './constants';
import MongoConsoleStore from './MongoConsoleStore';
import MongoConsoleService from '../services/MongoConsoleService';

export { default as MongoConsoleStore } from './MongoConsoleStore';

export function injectMongoConsoleStores(obj: RootStores) {
    const service = new MongoConsoleService();
    obj[STORE_MONGO_CONSOLE] = new MongoConsoleStore(service);
}

export type MongoConsoleStores = {
    [STORE_MONGO_CONSOLE]?: MongoConsoleStore;
};
